import { Component, OnDestroy, OnInit } from "@angular/core";
import { TemplateFacade } from "src/app/services/template.facade";
import { SubSink } from "subsink";
import { ICirculationTemplate } from "../../interfaces/circulation";
import { LogClass, Logger } from "../../logger";
import { NavigationService } from "../../services/navigation.service";

@Component({
    selector: "circ-new-metadata",
    templateUrl: "./new-metadata.component.html",
    styleUrls: ["./new-metadata.component.scss"],
    standalone: false
})
@LogClass({
  source: "Template/NewMetadataComponent"
})
export class NewMetadataComponent implements OnInit, OnDestroy {
  public template: ICirculationTemplate;
  public loading = true;
  private logger: Logger;
  private subscriptions = new SubSink();

  constructor(
    private navigate: NavigationService,
    private templateFacade: TemplateFacade
  ) {
    this.logger.debug("ctor");
  }

  public onSave(template: ICirculationTemplate): void {
    this.subscriptions.sink = this.templateFacade
      .save(template)
      .subscribe((id) => {
        this.logger.info("saved:" + id);
        this.navigate.toTemplate(id);
      });
  }

  public onAbort(): void {
    this.navigate.toTemplate(this.template.id);
  }

  ngOnInit(): void {
    this.subscriptions.sink = this.templateFacade
      .getCurrentTemplate()
      .subscribe(
        (template) => {
          this.logger.info("loaded template:" + template.id);
          this.template = template;
          this.loading = false;
        },
        (err) => {
          this.logger.error("loading template", err);
          this.loading = false;
          this.navigate.toError(err);
        }
      );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
